import { LOG_MODULES,APP_CONFIG } from "@config/config";
import { log } from '@libs/utils/helper.js';
import { zoomToWells, toggleSelection } from './utils';

const logFtTbl = LOG_MODULES.FEATURETABLBE;
export function bindMapClick({ mapView, table, highlightLayer, handlersRef }) {
  const isSublayer = false;
  // const isSublayer = true;

  const targetLayer = table.layer;
 
  const QueryId = APP_CONFIG.MAPS.Well.queryField;

  const mapClickHandle = mapView.on("click", async (event) => {
    let feature = null;

    if (isSublayer) {
      // --- Case: MapService Sublayer ---
      const query = targetLayer.createQuery();
      query.geometry = mapView.toMap(event);
      query.distance = 3; // buffer for easier clicking
      query.units = "pixels";
      query.returnGeometry = true;
      query.outFields = ["*"];

      const results = await targetLayer.queryFeatures(query);
      feature = results.features[0];
    } else {
      // --- Case: FeatureLayer ---
      const response = await mapView.hitTest(event, { include: [targetLayer] });
      if (response.results.length > 0) {
        feature = response.results[0].graphic;
      }
    }

    if (!feature) return;

   
    const object_id = feature.attributes[ targetLayer.object_idField || "OBJECTID"];
    let well_id=feature.attributes[QueryId] ?? "";
    if (QueryId === APP_CONFIG.MAPS.Well.specialWellId) well_id = (well_id).replace(/[{}]/g, "");

    console.error("bindMapClick well_id",well_id);
    // Logic Toggle
    const wasSelected = toggleSelection(well_id, handlersRef);

    // Visual Sync
    if (wasSelected) {
      table.highlightIds.remove(object_id);
      if (highlightLayer) highlightLayer.removeAll();
    } else {
      table.highlightIds.add(object_id);
      //table.scrollToRow(object_id);
      await zoomToWells(mapView, targetLayer, well_id, true, highlightLayer);
    }
  });

  return () => mapClickHandle.remove();
}
